import React from 'react'
import { Button } from 'components/ui'
import { HiX } from 'react-icons/hi'
import { useTranslation } from 'react-i18next'

const SelectedStoresSummary = ({ stores, onRemove, onClear, maxVisible = 50 }) => {
    const { t } = useTranslation()

    if (!stores || stores.length === 0) {
        return (
            <div className="rounded-md bg-gray-50 dark:bg-gray-800 p-3 text-sm text-gray-500 dark:text-gray-400">
                {t('no_stores_selected', { defaultValue: 'No hay tiendas seleccionadas aún' })}
            </div>
        )
    }

    return (
        <div className="rounded-md bg-gray-50 dark:bg-gray-800 p-3 border border-gray-200 dark:border-gray-600">
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">
                    {stores.length} {stores.length === 1 ? t('store_alias').toLowerCase() : t('stores_alias').toLowerCase()} {t('selected', { defaultValue: 'seleccionadas' })}
                </span>
                <Button
                    size="xs"
                    variant="plain"
                    onClick={onClear}
                    className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
                >
                    {t('clear_all', { defaultValue: 'Limpiar todo' })}
                </Button>
            </div>

            {/* Chips container */}
            <div className="flex flex-wrap gap-2 max-h-40 overflow-y-auto">
                {stores.slice(0, maxVisible).map((store) => (
                    <div
                        key={store.id}
                        className="flex items-center gap-1 px-3 py-1 rounded-full bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-200 text-sm"
                    >
                        <span className="truncate max-w-xs">{store.label || store.name}</span>
                        <button
                            type="button"
                            onClick={() => onRemove(store)}
                            className="flex-shrink-0 hover:bg-indigo-200 dark:hover:bg-indigo-800 rounded-full p-0.5 transition-colors"
                            aria-label={t('remove', { defaultValue: 'Quitar' })}
                        >
                            <HiX className="w-3.5 h-3.5" />
                        </button>
                    </div>
                ))}
                {stores.length > maxVisible && (
                    <div className="flex items-center px-3 py-1 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm font-semibold">
                        +{stores.length - maxVisible} {t('more', { defaultValue: 'más' })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default SelectedStoresSummary
